// FOUNDATION
import $ from 'jquery';
import 'jquery.cookie';
window.jQuery = $;

import 'what-input';
import './lib/foundation-explicit-pieces';

import { MegaMenu } from './lib/mega_menu';
import { ExternalLinkHandler } from "./lib/external_link_handler";
import { AppDownloadRouter } from "./lib/app_downloader";
import { LanguageDropDown } from './lib/language_dropdown';
import { PlayNowButton } from './lib/playNowButton';
import { LoginForm } from './lib/login';
import { ForgotPasswordPopup } from './lib/forgot_password';
import { CreateAccountPopup } from './lib/create_account';
import { FeaturedVideoPopup } from './lib/featured_video_popup';
import { PopExternalLinkWarning } from './lib/game/pop_external_link_warning';

function setupMegaMenu() {
	MegaMenu.setup('#megaMenu');
}

function setupLanguageDropDown() {
	LanguageDropDown.setup('.language-dropdown');
}
function setupExternalLinkHandler() {
	ExternalLinkHandler.setup({
		bindTo: 'a.external-link',
		popupTarget: '.external-link-warning-popup',
		dismissTarget: ['.btn-cancel', '.scrim'],
        confirmBtnTarget: '.btn-confirm',
		externalLinkTxtEl: '.external-link-txt'
	});
}

function setupAppDownloadRouter() {
	AppDownloadRouter.setup({
		downloadBtn: '.nav-bar .download-btn , .hero .download-btn',
		appStoreBtn: 'a.appstore',
		amazonAppStoreBtn: 'a.amazon',
		playStoreBtn: 'a.google-play',
		pcOrMacBtn: 'a.pc-download',
		popupSelector: '.come-back-on-your-pc-pop',
		popupDismiss: ['.ok-btn', '.scrim']
	})
}

function setupPlayNowButton() {
	PlayNowButton.setup('.login-link');
}

function setupForgotPasswordPopup() {
	ForgotPasswordPopup.setup({
		loginPopup: '.login-popup',
		link: '.forgot-pw-link',
		form: '.forgot-pass-form',
		popup: '.forgot-password-popup',
		confirmation: '#forgot-password-confirmation'
	})
}

function setupCreateAccountPopup() {
	CreateAccountPopup.setup({
		link: '.create-account-link',
		popup: '.create-account-popup'
	})
}

function setupLoginPopup() {
	LoginForm.setup('.login-form')
}

function setupPopExternalLinkWarning() {
	PopExternalLinkWarning.setup();
}

function setupFeaturedVideoPopup() {
	FeaturedVideoPopup.setup({
		popupTarget: '.featured-video-popup',
		videoThumbnail: '.featured-video-thumb',
		videoPopupCloseBtn: '.featured-video-popup-close-btn',
	});
}

$(document).ready(function($){
	$(document).foundation();
	setupMegaMenu();
	setupExternalLinkHandler();
	setupAppDownloadRouter();
	setupLanguageDropDown();
	setupPlayNowButton();
	setupForgotPasswordPopup();
	setupCreateAccountPopup();
	setupLoginPopup();
	setupFeaturedVideoPopup();
	setupPopExternalLinkWarning();
});

$(window).on('load', function() {
  if ($(window).width() > 770){
		setTimeout(
			function() {
				$(".header-banner").slideToggle(300);
    }, 750);
	}
});


